// React
import PropTypes from "prop-types";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

// Custom UI components
import { gql, useLazyQuery } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "50%", sm: "40%", xxl: "30%" },
  overflow: "visible",
};
export default function ModalExcel({ open, handleClose }) {
  const { handleSnackbar } = useContext(MessageManager);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  useEffect(() => {
    if (open) {
      setFechaInicio("");
      setFechaFin("");
    }
  }, [open]);
  const [getExcelData, { data, loading }] = useLazyQuery(
    gql`
      query ExcelPedidos($fechaInicio: String!, $fechaFin: String!) {
        ExcelPedidos(fechaInicio: $fechaInicio, fechaFin: $fechaFin) {
          idPedido
          totalPedido
          horaReserva
          turnoReserva
          cliente
          App
          tipoUsuario
          institucionConvenio
        }
      }
    `,
    {
      fetchPolicy: "network-only",
    }
  );

  const handleGenerateExcel = () => {
    if (!fechaInicio || !fechaFin)
      return handleSnackbar("Por favor complete todos los campos", "error");
    getExcelData({ variables: { fechaInicio, fechaFin } });
  };
  useEffect(() => {
    if (!data) return;

    const pedidos = data.ExcelPedidos || data.excelPedidos || [];

    if (pedidos.length === 0) {
      handleSnackbar("No se encontraron pedidos en ese rango", "info");
      return;
    }

    const pedidosLimpios = pedidos.map(({ __typename, ...rest }) => rest);
    const worksheet = XLSX.utils.json_to_sheet(pedidosLimpios);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pedidos");

    const nombreArchivo = `Pedidos_${fechaInicio}_a_${fechaFin}.xlsx`;
    XLSX.writeFile(workbook, nombreArchivo);
    handleClose();
  }, [data]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox pb={3}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={0}>
              <SoftBox>
                <SoftTypography variant="h6">Generar Excel</SoftTypography>
              </SoftBox>
              <SoftBox>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </SoftBox>
            </SoftBox>
            <SoftBox px={3}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <InputLabel>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Fecha Inicio
                    </SoftTypography>
                  </InputLabel>

                  <SoftInput
                    type="date"
                    fullWidth
                    onChange={(e) => setFechaInicio(e.target.value)}
                    value={fechaInicio}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputLabel>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Fecha Fin
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    type="date"
                    fullWidth
                    onChange={(e) => setFechaFin(e.target.value)}
                    value={fechaFin}
                  />
                </Grid>
              </Grid>
              <SoftBox
                display="flex"
                justifyContent="end"
                mt={2}
                gap={1}
                flexDirection={{ xs: "column", sm: "row" }}
              >
                <SoftButton color="primary" onClick={handleClose} circular>
                  Cancelar
                </SoftButton>
                <SoftButton
                  color="uproGreen"
                  circular
                  onClick={handleGenerateExcel}
                  disabled={loading || !fechaInicio || !fechaFin}
                >
                  Generar Excel
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalExcel.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
